"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePonyfill = void 0;
const global_this_1 = require("@tanker/global-this");
const { File } = global_this_1.globalThis;
// By default, suppose File doesn't need to be ponyfilled
let FilePonyfill = File;
exports.FilePonyfill = FilePonyfill;
try {
    // Only try and ponyfill if a previous File class exists (i.e. skip Node.js)
    if (File !== undefined) {
        new File([], '');
    }
}
catch (e) {
    // Create a File ponyfill with a working constructor and an ancestry
    // that will look like this: FilePonyfill < File < Blob
    exports.FilePonyfill = FilePonyfill = function (chunks, name, opts) {
        const blob = new Blob(chunks, opts || {});
        blob.name = name;
        blob.lastModified = opts && opts.lastModified || Date.now();
        blob.lastModifiedDate = new Date(blob.lastModified);
        // @ts-expect-error: cannot explicitly type 'this'
        Object.setPrototypeOf(blob, Object.getPrototypeOf(this));
        return blob;
    };
    const proto = Object.create(File.prototype);
    Object.defineProperty(proto, 'size', Object.getOwnPropertyDescriptor(Blob.prototype, 'size'));
    Object.defineProperty(proto, 'type', Object.getOwnPropertyDescriptor(Blob.prototype, 'type'));
    // @ts-expect-error feature detection for multiple environment 
    proto.slice = Blob.prototype.slice || Blob.prototype.mozSlice || Blob.prototype.webkitSlice;
    proto.constructor = FilePonyfill;
    FilePonyfill.prototype = proto;
}
//# sourceMappingURL=FilePonyfill.js.map